import Vue from "vue";
import VueAos from "vue-aos";
import App from "./App.vue";
import VueI18n from "vue-i18n";
import en from "./locales/en";
import tc from "./locales/tc";
import "./scss/main.scss";
import "animate.css";
// import VueVideoPlayer from "@videojs-player/vue";
// import VueParallaxJs from "vue-parallax-js";

Vue.use(VueI18n);
// Vue.use(VueParallaxJs);
Vue.use(VueAos);
// Vue.use(VueVideoPlayer);

const i18n = new VueI18n({
  locale:
    window.location.href.includes("/zh") || window.location.href.includes("/tc")
      ? "tc"
      : "en",
  messages: {
    en,
    tc,
  },
});

Vue.directive("in-viewport", {
  bind(el, binding) {
    const observer = new IntersectionObserver(([entry]) => {
      console.log("mounted");
      el.classList.add("animate__initial");
      if (entry.isIntersecting) {
        el.classList.add(binding.value);
      }
    });

    observer.observe(el);

    // Clean up the observer when the component is unmounted
    el._observer = observer;
  },
  unbind(el) {
    if (el._observer) {
      el._observer.disconnect();
      delete el._observer;
    }
  },
});

const AppInst = new Vue({
  el: "#app",
  i18n,
  render: (h) => h(App),
  mounted() {
    // You'll need this for renderAfterDocumentEvent.
    document.dispatchEvent(new Event("render-event"));
  },
});
